import React, { Component } from "react";
import { connect } from "react-redux";
import { ProgressBar } from "react-bootstrap";
import { I18n } from "react-i18nify";

class UploadProgress extends Component {
	render() {
		const uploadProgressStyle = {
			marginBottom: 0,
			marginTop: 0,
			position: "relative"
		};
		const divStyle = { marginTop: 2, marginLeft: 10 };
		let uploadProgress = null;

		if (this.props.uploadRunning) {
			const progressBarLabelStyle = {
				position: "absolute",
				display: "block",
				width: "100%",
				color: "black"
			};
			const progressBarLabel = (
				<span style={progressBarLabelStyle}>
					{this.props.uploadFile}
				</span>
			);
			uploadProgress = (
				<div style={divStyle}>
					{I18n.t("uploadFile.uploading")}
					<ProgressBar
						now={this.props.uploadProgress}
						label={progressBarLabel}
						style={uploadProgressStyle}
					/>
				</div>
			);
		}

		return uploadProgress;
	}
}

const mapStateToProps = function(store) {
	return {
		uploadFile: store.uploadState.fileName,
		uploadProgress: store.uploadState.progress,
		uploadRunning: store.uploadState.running
	};
};

export default connect(mapStateToProps)(UploadProgress);



// WEBPACK FOOTER //
// ./src/components/views/utils/UploadProgress.js